// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_hm","advertCardList_max6":"c-a_hn"};